import axios from 'axios'

export default function makeCancellable(client) {
    const runningRequests = {}
    client.interceptors.request.use(function transformCancelId(config) {
        if (!config.cancelId) {
            return config
        }

        // If a request was already done using the same unique ID, cancel it before starting the next one.
        if (runningRequests.hasOwnProperty(config.cancelId)) {
            runningRequests[config.cancelId].cancel()
            delete runningRequests[config.cancelId]
        }

        // Generate a new cancelSource for this unique cancelID
        let cancelSource = axios.CancelToken.source()
        runningRequests[config.cancelId] = cancelSource

        // Bind the cancelToken to the axios config so it can actually be cancelled.
        config.cancelToken = cancelSource.token

        // Delete our custom cancelId config prop, axios doesn't need to be aware.
        delete config.cancelId
        return config
    })
    return client
}
